export const CONVERT_START = "CONVERT_START";
export const CONVERT_SUCCESS = "CONVERT_SUCCESS";
export const CONVERT_FAIL = "CONVERT_FAIL";
export const PREVIEW_CONVERSION_START = "PREVIEW_CONVERSION_START";
export const PREVIEW_CONVERSION_SUCCESS = "PREVIEW_CONVERSION_SUCCESS";
export const PREVIEW_CONVERSION_FAIL = "PREVIEW_CONVERSION_FAIL";
export const RESET_CONVERT_STATE = "RESET_CONVERT_STATE";